import { render, staticRenderFns } from "./deviceView.vue?vue&type=template&id=2179749d&scoped=true&"
import script from "./deviceView.vue?vue&type=script&lang=js&"
export * from "./deviceView.vue?vue&type=script&lang=js&"
import style0 from "./deviceView.vue?vue&type=style&index=0&id=2179749d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2179749d",
  null
  
)

export default component.exports